import { COPY_GFC_BRAND, MOVE_GFC_BRAND } from '../actions/GroupActions';

const defaultState = {
  copying: false,
  copySuccess: false,
  copyError: null,
  copiedBrand: null,
  moving: false,
  moveSuccess: false,
  moveError: null,
  movedBrand: null
};

const groupReducer = (state = defaultState, action) => {
  switch (action.type) {
    case `${COPY_GFC_BRAND}_BEGIN`:
      return {
        ...state,
        copying: true,
        copySuccess: false,
        copyError: null,
        copiedBrand: null
      };

    case `${COPY_GFC_BRAND}_SUCCESS`:
      return {
        ...state,
        copying: false,
        copySuccess: true,
        copiedBrand: action.result
      };

    case `${COPY_GFC_BRAND}_FAILURE`:
      return {
        ...state,
        copying: false,
        copyError:
          (action.error && action.error.message) || 'Failed to copy group'
      };

    case `${MOVE_GFC_BRAND}_BEGIN`:
      return {
        ...state,
        moving: true,
        moveSuccess: false,
        moveError: null,
        movedBrand: null
      };

    case `${MOVE_GFC_BRAND}_SUCCESS`:
      return {
        ...state,
        moving: false,
        moveSuccess: true,
        movedBrand: action.result
      };

    case `${MOVE_GFC_BRAND}_FAILURE`:
      return {
        ...state,
        moving: false,
        moveError:
          (action.error && action.error.message) || 'Failed to move group'
      };

    default:
      return state;
  }
};

export default groupReducer;
